import React, { SVGAttributes } from 'react';

import { ExtendAndOverride } from '../../utils/ExtendAndOverride';
import { getTranslateTransform } from '../../utils/getTranslateTransform';

interface GroupOwnProps {
  /**
   * The left (x) offset to apply to the group. Applied via a `translate` transform.
   */
  left?: number;
  /**
   * The top (y) offset to apply to the group. Applied via a `translate` transform.
   */
  top?: number;
}

export type GroupProps = ExtendAndOverride<GroupOwnProps, SVGAttributes<SVGGElement>>;

/**
 * A convenience wrapper for an SVG `g` element.
 */
export const Group = React.forwardRef<SVGGElement, GroupProps>(({ top = 0, left = 0, ...gProps }, ref) => (
  <g ref={ref} transform={getTranslateTransform(left, top)} {...gProps} />
));
